const AbstractDojoRequestRecord = require('./AbstractDojoRequestRecord');
const DojoConfig = require('../../DojoConfig');

class DojoTransactionPollRequestRecord extends AbstractDojoRequestRecord {
    /**
     * @param {DojoConfig} config
     * @param {String} requestId
     */
    constructor(config, requestId) {
        if (!(config instanceof DojoConfig)) {
            throw new Error('Required instance of DojoConfig is missing');
        }
        if (!requestId) {
            throw new Error('requestId is required');
        }
        const url = 'pac/terminals/' + config.terminalId + '/transactions/' + requestId;
        super(
            'GET',
            url
        );
    }
}

module.exports = DojoTransactionPollRequestRecord;
